import format from 'date-fns/format'
import enUs from 'date-fns/locale/en-US'
import flatpickr from 'flatpickr'

export default class DateFormat {
  constructor() {
    this.formats = {
      STANDARD: 'P p'
    }


    // TRANSFORM UTC DATES TO LOCAL TIME.
    // ---------------------------------------------
    this.updateDomDates('[sd-date]');

    this.dateTimePickers = document.querySelectorAll("input.js-datetime-picker");
    if (this.dateTimePickers.length) {
      for (const picker of this.dateTimePickers) {
        this.initDateTimePickers(picker);
      }
    }
  }

  /**
   * Transform local date to UTC string.
   * @param {Date} date
   * @returns {string} Return date string: Y-m-d H:i:s
   */
  localToUTCString(date) {
    return date.toISOString().replace('T', ' ').slice(0, 19)
  }

  /**
   *
   * @param {String} date Date in format YYYY-MM-DD HH:MM:SS (also ISO8601 is supported eg. 2020-10-02T20:32:23+0000). This date should be UTC!
   * @param formatStr Format compatible with https://date-fns.org/v2.15.0/docs/format
   */
  formatDate(date, formatStr) {
    const type = typeof date;

    if (type === 'string') {
      let parts = date.match(/^(\d{4})-(\d{2})-(\d{2})(?:\s|T)(\d{2}):(\d{2}):(\d{2})/)

      if (Array.isArray(parts) && parts.length === 7) {
        parts.shift()
        parts = parts.map((value) => parseInt(value))

        date = new Date(Date.UTC(parts[0], parts[1]-1, parts[2], parts[3], parts[4], parts[5]))
      } else {
        throw TypeError('Invalid date format: '+date)
      }
    } else {
      throw TypeError('formatDate first argument should date string in format 2020-12-31 14:28:35')
    }

    return format(date, formatStr || this.formats.STNADARD, {
      locale: enUs
    })
  }

    /**
   * This function initialize date pickers on page.
   *
   * It can be called multiple times if needed (if new date picker was dynamically added
   * to page); currently inited pickers will not be processed twice.
   *
   * Available configuration attribute:
   * - `sd-dtp-time` - show time picker
   * - `sd-dtp-format` - Format of the date showed to user
   *
   * `sd` - solodev
   * `dtp` - date time picker
   */
    initDateTimePickers(picker) {
      const me = this;
        // Convert every input with class "js-datetime-picker" to date picker.
        // Don't init same input twice.
        if (picker.getAttribute("sd-dtp-inited") === "true") {
          return;
        }
        // Create new input in which we will store date which will be sent to server.
        // Value of this input will always store date in UTC.
        const input = document.createElement("input");
        input.name = picker.name;
        input.value = picker.value;
        input.type = "hidden";
        picker.parentNode.insertBefore(input, picker);

        // Existing input will store date in user local time.
        picker.name = "";
        if (input.value) {
          picker.value = this.formatDate(input.value, "yyyy-MM-dd HH:mm:ss");
        }

        // Create instance of flatpickr.
        const instance = flatpickr(picker, {
          enableTime: picker.getAttribute("sd-dtp-time") === "true",
          altInput: true,
          altFormat: picker.getAttribute("sd-dtp-format") || "F j, Y",
          static: true,
          // Every time flatpickr value is updated, change date to UTC and put it
          // in our "hidden" input.
          onValueUpdate(dates) {
            input.value = me.localToUTCString(dates[0]);
          },
        });

        // Click on calendar icon next to input opens date picker.
        const inputGroup = picker.closest(".input-group").querySelector(".input-group-addon");
        if(inputGroup) {
          inputGroup.addEventListener("click", () =>
              instance.open()
          );
        }

        // Mark this element as inited.
        picker.setAttribute("sd-dtp-inited", "true");
    }

  /**
   * This function will look for elements matching provided selector
   * and replace UTC date in elements attribute to local time.
   *
   * Example worth a thousand words:
   *
   *     <span sd-date="2020-02-01 20:32:23"></span>
   *
   *     // Executing this method...
   *     updateDomDate('[sd-date]')
   *
   *     // Will change above span to:
   *     <span sd-date="2020-02-01 20:32:23">2020-02-01 19:32:23</span>
   *
   * You can also provide additional span attribute `sd-date-format` which should
   * contain date format https://date-fns.org/v2.15.0/docs/format
   *
   * @param {String} selector
   */
  updateDomDates(selector) {
    const elements = document.querySelectorAll(selector);
    let len = elements.length, element, dateFormat, date;

    while (len--) {
      element = elements[len];

      if (!element.hasAttribute('sd-date-parsed') || !element.getAttribute('sd-date-parsed') === false) {
        try {
          dateFormat = element.getAttribute('sd-date-format') || '@STANDARD';
          if (dateFormat[0] === '@') {
            dateFormat = this.formats[dateFormat.slice(1).toUpperCase()];
          }
          date = element.getAttribute('sd-date');

          if (date) {
            element.innerHTML = this.formatDate(date, dateFormat);
            element.setAttribute('sd-date-parsed', 'true');
          }
        } catch (e) {
          element.setAttribute('sd-date-parsed', 'false');
        }
      }
    }
  }
}
